/**
 * Message d'accès refusé unifié pour les rubriques Super Admin (RPC `super_admin` only).
 * Cause la plus fréquente : le compte connecté n'est pas `super_admin` (c'est un admin de resto).
 */
export default function AccessDenied({ title, sqlFile }: { title: string; sqlFile?: string }) {
  return (
    <div className="max-w-2xl">
      <h1 className="mb-1 text-xl font-bold">{title}</h1>
      <div className="rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-900">
        <p className="font-semibold">🔒 Réservé au super admin</p>
        <p className="mt-1">Cette rubrique lit des données de tout le réseau. Pour y accéder :</p>
        <ol className="mt-2 list-decimal pl-5">
          <li>
            Connecte-toi avec le <strong>compte super admin</strong> (pas un compte admin de restaurant).
          </li>
          <li>
            Ce compte doit avoir <code>role = 'super_admin'</code> dans <code>public.users</code>.
          </li>
          {sqlFile && (
            <li>
              Vérifie aussi que <code>{sqlFile}</code> est bien lancé en base.
            </li>
          )}
        </ol>
        <p className="mt-2 opacity-80">
          Astuce : exécute <code>SQL_SUPERADMIN_acces.sql</code> pour vérifier/attribuer le rôle.
        </p>
      </div>
    </div>
  );
}
